import * as React from 'react';
import { Link, Navigate } from 'react-router-dom';
import store from '../../../Store';
import logo from '../../../images/logo.svg';
import Cookies from 'js-cookie';

export interface ILoginProps {}

export interface ILoginState {
  email: string;
  password: string;
  error: string;
  msg: string;
  data: any;
  redirectToMain: boolean;
  rememberMe: boolean;
}

export default class Login extends React.Component<ILoginProps, ILoginState> {
  constructor(props: ILoginProps) {
    super(props);
    this.state = {
      email: localStorage.getItem('rememberedEmail') || '',
      password: '',
      error: '',
      msg: '',
      data: {},
      redirectToMain: false,
      rememberMe: localStorage.getItem('rememberMe') === 'true',
    };
  }

  componentDidMount() {
    // التحقق من وجود token وإعادة توجيه المستخدم إذا كان مسجل دخول
    const token = localStorage.getItem('admin_token');
    if (token) {
      console.log('Login: User already authenticated, redirecting to admin panel');
      globalThis.location.href = '/admin/dashboard';
    }
    
    // إضافة رسالة ترحيب للمستخدمين الجدد
    console.log('Login: Login page loaded');
    console.log('Login: Welcome to Spinndo Admin Panel');
  }

  handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = e.target;
    this.setState((prevState) => ({
      ...prevState,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  handleLogin = async () => {
    const { email, password } = this.state;
    
    if (this.state.rememberMe) {
      localStorage.setItem('rememberedEmail', email);
      localStorage.setItem('rememberMe', 'true');
    } else {
      localStorage.removeItem('rememberedEmail');
      localStorage.removeItem('rememberMe');
    }

    try {
      const response = await store.signIn(email, password);

      if (response.success) {
        const token = response.data?.token || response.data?.access_token;
        const user = response.data?.user || response.data;

        if (token) {
          localStorage.setItem('admin_token', token);
          Cookies.set('token', token, { expires: 1 });
        }
        if (user?.id) Cookies.set('id', String(user.id), { expires: 1 });
        if (user?.role) Cookies.set('role', user.role, { expires: 1 });

        this.setState({ redirectToMain: true, error: '' });
        console.log('Login success:', response);
      } else {
        this.setState({
          error: response.message || 'Login failed.',
          redirectToMain: false,
        });
        console.log('Login failed:', response.message);
      }
    } catch (error: any) {
      console.error('Login Error:', error);
      this.setState({
        error: error.message || 'Network error. Please try again.',
      });
    }
  };

  handleKeyPress = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter') {
      this.handleLogin();
    }
  };

  public render(): JSX.Element {
    // التحقق من التوكن في localStorage بدلاً من Cookies
    const hasToken = localStorage.getItem('admin_token');
    console.log('Login: Render check - redirectToMain:', this.state.redirectToMain, 'isAuthenticated:', store.isAuthenticated, 'hasToken:', !!hasToken);
    
    if (this.state.redirectToMain || store.isAuthenticated || hasToken) {
      console.log('Login: Redirecting to dashboard');
      return <Navigate to="/admin/dashboard" replace />;
    }

    return (
      <div className="flex flex-col items-center justify-center px-6 pt-8 mx-auto md:h-screen pt:mt-0 dark:bg-gray-900">
        <img src={logo} className="mr-4 h-11" alt="FlowBite Logo" />
        <span>Flowbite</span>

        <div className="w-full max-w-xl p-6 space-y-8 sm:p-8 bg-white rounded-lg shadow dark:bg-gray-800">
          <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
            Sign in to platform
          </h2>
          <form
            className="mt-8 space-y-6"
            onSubmit={(e) => {
              e.preventDefault();
              this.handleLogin();
            }}
          >
            <div>
              <label
                htmlFor="email"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Your email
              </label>
              <input
                type="email"
                name="email"
                id="email"
                className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                placeholder="name@company.com"
                required
                value={this.state.email}
                onChange={this.handleInputChange}
                onKeyDown={this.handleKeyPress}
              />
            </div>
            <div>
              <label
                htmlFor="password"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Your password
              </label>
              <input
                type="password"
                name="password"
                id="password"
                placeholder="••••••••"
                required
                value={this.state.password}
                className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                onChange={this.handleInputChange}
              />
            </div>
            <div className="flex items-start">
              <div className="flex items-center h-5">
                <input
                  id="rememberMe"
                  name="rememberMe"
                  type="checkbox"
                  checked={this.state.rememberMe}
                  onChange={this.handleInputChange}
                  className="w-4 h-4 border-gray-300 rounded bg-gray-50 focus:ring-3 focus:ring-primary-300 dark:focus:ring-primary-600 dark:ring-offset-gray-800 dark:bg-gray-700 dark:border-gray-600"
                />
              </div>
              <div className="ml-3 text-sm">
                <label
                  htmlFor="rememberMe"
                  className="font-medium text-gray-900 dark:text-white"
                >
                  تذكرني
                </label>
              </div>
            </div>

            <button
              type="submit"
              className="w-full px-5 py-3 text-base font-medium text-center text-white bg-primary-700 rounded-lg hover:bg-primary-800 focus:ring-4 focus:ring-primary-300 dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800"
            >
              Login to your account
            </button>
            <div className="text-sm font-medium text-gray-500 dark:text-gray-400">
              <Link to="/NewAccount" className="hover:underline">
                Create a new account
              </Link>
            </div>
          </form>

          {this.state.error && (
            <div className="text-red-500 text-sm mt-2">{this.state.error}</div>
          )}
          {this.state.msg && (
            <div className="text-green-500 text-sm mt-2">{this.state.msg}</div>
          )}
        </div>
      </div>
    );
  }
}
